export default __webpack_public_path__ + "static/media/drum_&_bass.bc3e8c5e.png";